import { Injector } from "@angular/core";
import { AutoUploadEntityEnum } from "../../../AutoUploadEntityEnum";
import { ServiceEnum } from "../../../ServiceEnum";
import { BaseNode } from "../../BaseNode";
import { AuthorisedProductEntity } from "../../../Data/MedicinalProductData/AuthorisedProductEntity";
import { TreeNodeProductsList } from "../../Art57Node/ListEntity/TreeNodeProductsList";
import { MAHAutoUploadEntity } from "./MAHAutoUploadEntity";
import { TreeNodeMedicinalProductsProductATC } from "../ListEntity/TreeNodeMedicinalProductsProductATC";
import { getProductVersionItems, TreeNodeMedicinalProductsPreviousProductVersion, VersionTypeEnum } from "../ListEntity/TreeNodeMedicinalProductsPreviousProductVersion";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";
import { EntityEnum } from "../../EntityEnum";
import { MFLAutoUploadEntity } from "./MFLAutoUploadEntity";
import { TreeNodeMedicinalProductsMPT } from "../ListEntity/TreeNodeMedicinalProductsMPT";
import { TreeNodeMedicinalProductsDrugIndication } from "../ListEntity/TreeNodeMedicinalProductsDrugIndication";
import { TreeNodeMedicinalProductsProductPreviousEvCode } from "../ListEntity/TreeNodeMedicinalProductsProductPreviousEvCode";
import { TreeNodeMedicinalProductsAttachments } from "../ListEntity/TreeNodeMedicinalProductsAttachments";
import { TreeNodeMedicinalProductPharmaceuticalProducts } from "../ListEntity/TreeNodeMedicinalProductPharmaceuticalProducts";
import { TreeNodeMedicinalProductAuthorisedPharmaceuticalForm } from "../ListEntity/TreeNodeMedicinalProductAuthorisedPharmaceuticalForm";
import { TreeNodeMedicinalProductsReportingName as TreeNodeMedicinalProductsReportingName } from "../ListEntity/TreeNodeMedicinalProductsReportingName";
import { TreeNodeMedicinalProductsQPPV } from "../ListEntity/TreeNodeMedicinalProductsQPPV";
import { environment } from "../../../../../../environments/environment";
import { OnDemandAutoUploadNode } from "../OnDemandAutoUploadNode";
import { OnDemandSimpleSearchListNode } from "../../OnDemandSimpleSearchListNode";
import { AuthService } from "../../../../service/auth-service/auth-service.service";
import { TreeNodeMedicinalProductOperationResult } from "../ListEntity/TreeNodeMedicinalProductOperationResult";

export class AuthorisedProductAutoUploadEntity extends OnDemandAutoUploadNode {
    useHist: boolean = false;

    constructor(injector: Injector, labelTemplate: string, parent: BaseNode, model: any, useHist: boolean, disableAutoUpload:boolean,cloningNode:boolean) {
        super(injector, 
            labelTemplate, 
            AuthorisedProductEntity, 
            useHist ? AutoUploadEntityEnum.authorisedProductHist : AutoUploadEntityEnum.authorisedProduct, 
            ServiceEnum.MedicinalProducts, 
            parent, 
            model, 
            TreeNodeProductsList, 
            !cloningNode, 
            disableAutoUpload,
            cloningNode,
            { nodeTypeToCreateName: 'addAuthorisedProduct' });
            this.labelNodeName = 'Authorised Product';
            this.useHist = useHist;
    }

    override cloneNode(newParent: BaseNode): BaseNode|undefined {
      const labelTemplate = this.labelTemplate;
      let clonedNode: AuthorisedProductAutoUploadEntity = new AuthorisedProductAutoUploadEntity(this.ioc!, `${labelTemplate}`,newParent,this.datasource, this.useHist, this.isLoaded, true);      
      clonedNode.loadEntity();
      clonedNode.isLoading = false;

      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
  
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

  
      this.children?.forEach((child) => {
        let childToClone = child as BaseNode;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
      clonedNode.cloningNode = false;
      return clonedNode;
    }

    override postLoadEntity(model: any): void {

        if (model.mah) {
            this.children?.push(new MAHAutoUploadEntity(this.ioc!, "MAH: "+ model.mah.ev_Code + " - " + model.mah.name_Org, this, model.mah,false,true, false));
        }

        if (model.mfl) {
            this.children?.push(new MFLAutoUploadEntity(this.ioc!, "MFL: " + model.mfl.ev_Code + " - " + model.mfl.masterfiledesc,this,model.mfl,false,true, false));
        }

        if (model.qppv)  {
            this.children?.push(new TreeNodeMedicinalProductsQPPV(this.ioc!, "QPPV: " + model.qppv.name + " " + model.qppv.family + ' (' + model.qppv.orgid + ') - ' + model.qppv.maskedQppvCode, this, model.qppv));            
        }

        this.children?.push(new TreeNodeMedicinalProductsMPT(this.ioc!, this, false, model.authorisation && model.authorisation.medicinalproducttypes?model.authorisation.medicinalproducttypes.medicinalproducttype:[]));
        this.children?.push(new TreeNodeMedicinalProductAuthorisedPharmaceuticalForm(this.ioc!,this,false, model.authpharmforms?model.authpharmforms.authpharmform:[], false));
        this.children?.push(new TreeNodeMedicinalProductPharmaceuticalProducts(this.ioc!,this,false,false,model.pharmaceuticalproducts?model.pharmaceuticalproducts.pharmaceuticalproduct:[]));
        this.children?.push(new TreeNodeMedicinalProductsProductATC(this.ioc!,this, false, model.atccodes));
        this.children?.push(new TreeNodeMedicinalProductsDrugIndication(this.ioc!,this, false, model.productindications?model.productindications.productindication:[]));
        this.children?.push(new TreeNodeMedicinalProductsProductPreviousEvCode(this.ioc!, this, false, model.previousevcodes?model.previousevcodes.previousevcode:[]));
        this.children?.push(new TreeNodeMedicinalProductsAttachments(this.ioc!,'Product',this,false, model.ppiattachments?model.ppiattachments.ppiattachment:[]));            
        this.children?.push(new TreeNodeMedicinalProductsPreviousProductVersion(this.ioc!,model.ev_Code,model.revision,EntityEnum.authorisedProduct,VersionTypeEnum.previous, this, false, false, false, getProductVersionItems(model, VersionTypeEnum.previous)));
        this.children?.push(new TreeNodeMedicinalProductsPreviousProductVersion(this.ioc!,model.ev_Code,model.revision,EntityEnum.authorisedProduct,VersionTypeEnum.subsequent, this, false, false, false, getProductVersionItems(model, VersionTypeEnum.subsequent)));
        this.children?.push(new TreeNodeMedicinalProductsReportingName(this.ioc!,model.id, EntityEnum.presentationName, this,false, false, false));
        this.children?.push(new TreeNodeMedicinalProductsReportingName(this.ioc!,model.id, EntityEnum.scientificName, this, false, false, false));
        if (this.ioc!.get(AuthService).isEMAOrganisation()) {
            this.children?.push(new TreeNodeMedicinalProductOperationResult(this.ioc!, this, false, model.operationResults?model.operationResults:[], EntityEnum.operationResult));
            this.children?.push(new TreeNodeMedicinalProductOperationResult(this.ioc!, this, false, model.allOperationResults?model.allOperationResults:[], EntityEnum.allOperationResult));
        }
    }

    public getListItem(): any[] {
        return [this.data.model.ev_Code, 
            this.data.model.version, 
            this.ioc!.get(LookupGetService).retrieveValueFromCache(
                    'productstatus',
                    this.data.model.product_version_status
                  ), 
            this.ioc!.get(LookupGetService).retrieveValueFromCache(
                    'productversion',
                    this.data.model.product_version_validity
                  ), 
            this.data.model.productname,
            this.data.model.productshortname];
    }

    override getOnDemandEntities() {
        if (this.parent instanceof OnDemandSimpleSearchListNode) {
            const onDemandEntities: any = super.getOnDemandEntities();
            if (Array.isArray(onDemandEntities ) || Object.keys(onDemandEntities ).length !== 0) {
                return {id: this.code, ...onDemandEntities};
            }
            return {};
        } else {
            return {...this.initialModel};
        }
    }
}